export function setCityList(state, value) {
    state.cityList = value;
}

export function setMainMenu(state, value) {
    state.mainMenu = value;
}
